<div [attr.data-qa]="postalCodeQaId?.baseId">
  <ng-container #container></ng-container>
</div>

<div #postalCodeContainer class="form-container">
  <div class="inner-container">
    <form
      class="d-flex align-items-end"
      (ngSubmit)="submitPostalCode()"
      [formGroup]="postalCodeForm"
    >
      <app-form-input>
        <app-form-label [class.label-error]="postalCodeHasError">{{
          'postalCode.label' | cxTranslate
        }}</app-form-label>
        <input
          [attr.data-qa]="postalCodeInputQaId?.getInputId()"
          appFormInput
          formControlName="postalCode"
          type="text"
          [placeholder]="'postalCode.placeholder' | cxTranslate"
          [class.hasError]="postalCodeHasError"
        />
        <div *ngIf="postalCodeHasError" class="form-error">
          {{ 'postalCode.error' | cxTranslate }}
        </div>
      </app-form-input>

      <button
        class="btn btn-primary"
        [disabled]="
          !postalCodeForm.get('postalCode')?.dirty && !postalCodeForm.get('postalCode')?.touched
        "
        [attr.data-qa]="postalCodeButtonQaId?.getButtonId()"
        appFormInputButton
        type="submit"
      >
        {{ 'postalCode.button' | cxTranslate }}
      </button>
    </form>

    @if (isSubmittedAndValid && contactData?.fieldServiceEmployee) {
      <div class="d-flex flex-column content-wrapper w-100">
        <div class="d-flex align-items-center contact-data">
          <img [src]="contactData.image" [alt]="contactData.fieldServiceEmployee" />
          <div class="d-flex flex-column">
            <div class="overtitle">
              {{ 'postalCode.responsible' | cxTranslate: { city: contactData.city } }}
            </div>
            <div class="name">{{ contactData.fieldServiceEmployee }}</div>
            <div class="phone d-none d-md-flex">
              {{ 'postalCode.phone' | cxTranslate: { phone: contactData.phone } }}
            </div>
            <div class="email d-none d-md-flex">{{ contactData.email }}</div>
          </div>
        </div>
        <div class="phone d-flex d-md-none pt-6">
          {{ 'postalCode.phone' | cxTranslate: { phone: contactData.phone } }}
        </div>
        <div class="email d-flex d-md-none">{{ contactData.email }}</div>
      </div>
    } @else if (isSubmittedAndValid && contactData?.city) {
      <div class="d-flex flex-column content-wrapper">
        <div class="contant-not-found">
          {{ 'postalCode.contactNotFound' | cxTranslate: { city: contactData.city } }}
        </div>
        <div class="phone">
          {{ 'postalCode.phone' | cxTranslate: { phone: '+49 9564 929 60013' } }}
        </div>
        <div class="email" [innerHTML]="'kontakt@wehrfritz.com'"></div>
      </div>
    } @else {
      <p class="m-0 text-center content-wrapper">{{ 'postalCode.info' | cxTranslate }}</p>
    }
  </div>
</div>
